import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface PercentNumberFieldProps {
  value: number;
  onChange: (value: number | undefined) => void;
}

const PercentNumberField: React.FC<PercentNumberFieldProps> = ({ value, onChange }) => {
  return (
    <NumericFormat
    className="ant-input noBoderColor number-input"

      value={value! * 100.0}
      decimalSeparator=","
      decimalScale={2}
      suffix="%"
      fixedDecimalScale={true}
      onValueChange={(values, sourceInfo) => {
        onChange(values.floatValue! / 100.0);
      }}
    />
  );
};

export default PercentNumberField;
